// Common footer link class names, shared between all footer link components
export const linkClassNames = "mb-2 hover:underline underline-offset-8"

export { Footer } from "./Footer"
